import axios from 'axios';
import {rootUrl} from './rootUrl.js';
export let other={
  // 身份验证--验证码校验接口
  captcha(params) {
    return axios.post(rootUrl + '/captcha', params)
  },
// 身份验证--短信验证码接口
  sendCode(params) {
    return axios.post(rootUrl + '/sms/sendCode', params)
  },
  //意见反馈
  createLeaveMessage(params) {
    return axios.post(rootUrl + '/leaveMessage/createLeaveMessage', params)
  },
  //常见问题
  getQuestion(params) {
    return axios.post(rootUrl + '/applicantInfo/getQuestion', params)
  },
   // 消息通知已读状态
  getNoticeType(params) {
    return axios.post(rootUrl + '/memberMessage/getNoticeType', params)
  },
};



// WEBPACK FOOTER //
// ./src/service/other.js